var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.srcParsed)?_c('img',_vm._g(_vm._b({staticClass:"base-image",attrs:{"src":_vm.srcParsed,"srcset":_vm.srcSet}},'img',_vm.$attrs,false),_vm.$listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }